import type { RouteRecordRaw } from 'vue-router'

// Auth module route paths. Referenced via this constant so a path change is a
// single edit — never hard-code the string at call sites.
//
// The seller portal has a SINGLE entry point: `/login` offers both sign-in
// methods — UAE PASS and an email one-time code — and the email method
// continues on `/login/email` (there is no separate sign-up screen: new sellers
// are auto-registered after the UAE PASS callback, and a code is only mailed to
// an address that already has an account). `/login` is also where the router
// guard and the axios session-expiry redirect land, so it must exist.
export const authPaths = {
  LOGIN: '/login',
  LOGIN_EMAIL: '/login/email',
  VERIFY_OTP: '/login/verify',
  UAE_PASS_CALLBACK: '/auth/uae-pass/callback',
} as const

// Pre-auth routes, mounted under the SignUpLayout shell.
//
// - LOGIN and LOGIN_EMAIL are guests-only (authenticated users are bounced to
//   the dashboard by the router guard).
// - VERIFY_OTP is guests-only for the same reason. It is reachable only by
//   going through LOGIN first: the challenge lives in the auth store, so
//   opening this URL cold bounces straight back to LOGIN.
// - UAE_PASS_CALLBACK is intentionally guard-less: it runs on return from UAE
//   Pass to resolve the outcome (login or new-seller sign-up) and must execute
//   regardless of the current auth state.
export const authRoutes: RouteRecordRaw[] = [
  {
    path: authPaths.LOGIN,
    name: 'LOGIN',
    component: () => import('./SignUpPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: authPaths.LOGIN_EMAIL,
    name: 'LOGIN_EMAIL',
    component: () => import('./EmailSignInPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: authPaths.VERIFY_OTP,
    name: 'VERIFY_OTP',
    component: () => import('./VerifyOtpPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: authPaths.UAE_PASS_CALLBACK,
    name: 'UAE_PASS_CALLBACK',
    component: () => import('./UaePassCallbackPage.vue'),
  },
]
